import React from 'react'

type Props = {
  children: React.ReactNode
  isOpen: boolean
}

function Flyout(
  props: Props
): JSX.Element {
  const {
    children,
    isOpen
  } = props

  const baseClassName = 'flyout'

  const className = isOpen 
    ? `${baseClassName} open`
    : baseClassName

  return (
    <div className={ className }>
      { children }
    </div>
  )
}

export default Flyout
